export default "__VITE_ASSET__CQhOXNh$__"